import { useSnackbar } from 'notistack';
import { useMemo } from 'react';
import { errorMessage } from '@/api/errors';

/** Toasts for mutation results. */
export function useNotify() {
  const { enqueueSnackbar } = useSnackbar();
  return useMemo(
    () => ({
      success: (message: string) => enqueueSnackbar(message, { variant: 'success' }),
      error: (error: unknown) => enqueueSnackbar(errorMessage(error), { variant: 'error' }),
      info: (message: string) => enqueueSnackbar(message, { variant: 'info' }),
    }),
    [enqueueSnackbar],
  );
}
